import { PaginatedEventDocuments } from "../queries/event-documents.queries";

export const eventDocumentsQueryKeys = {
  all: ["eventDocuments"] as const,
  lists: () => [...eventDocumentsQueryKeys.all, "lists"] as const,
  list: (eventId: string, structureId: string) =>
    [...eventDocumentsQueryKeys.lists(), eventId, structureId] as const,
  filteredList: (
    eventId: string,
    structureId: string,
    params: PaginatedEventDocuments
  ) => [...eventDocumentsQueryKeys.list(eventId, structureId), params] as const,
  details: () => [...eventDocumentsQueryKeys.all, "details"] as const,
  detail: (eventDocumentId: string) =>
    [...eventDocumentsQueryKeys.details(), eventDocumentId] as const,
};
